import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tabs, Tab } from 'react-bootstrap';
import Panel from '../../../../components/angle/Panel/index';
import Spinner from '../../../../components/Spinner';
import { FILING_STATUS } from '../../../../services/constant/constant';

import SearchReadyForRenewalPanel from './SearchReadyForRenewalPanel';
import SearchByFileByDatePanel from './SearchByFileByDatePanel';
import SearchAllActiveFilingsPanel from './SearchAllActiveFilingsPanel';
import SearchEverActiveFilingsPanel from './SearchEverActiveFilingsPanel';
import SearchTerminatedFilingsPanel from './SearchTerminatedFilingsPanel';
import FilingsReadyForRenewalListGrid from './FilingsReadyForRenewalListGrid';
import FilingsByFileByDateListGrid from './FilingsByFileByDateListGrid';
import FilingsAllActiveListGrid from './FilingsAllActiveListGrid';
import FilingsTerminatedListGrid from './FilingsTerminatedListGrid';
import FilingsEverActiveListGrid from './FilingsEverActiveListGrid';

import { fetchAllClientInformationData } from '../../../../services/redux/employee/clientInformation/actions';
import {
    fetchFilingById,
    updateFilingInfoData,
    fetchClientData,
    fetchStateData,
    changeStatusFilingList,
    fetchFilingsReadyForRenewal,
    fetchFilingsByFileByDate,
    fetchActiveFilingsByClientId,
    fetchTerminatedFilings,
    fetchEverActiveFilings,
    clearFilingsReadyForRenewalTab,
    clearFilingsByClientTab,
    clearTerminatedFilingsTab,
    clearEverActiveFilingsTab,
    updateSelectedFilingList,
    updateFilingsActiveTabKey,
    updateClientSelected
} from '../../../../services/redux/employee/filing/actions';

class SearchFilings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTabKey: 1
        };
    }

    componentDidMount() {
        let {
            fetchAllClientInformationData,
            filing,
            location,
            clearFilingsReadyForRenewalTab,
            clearFilingsByClientTab,
            clearTerminatedFilingsTab,
            clearEverActiveFilingsTab
        } = this.props;
        if (location.from && location.from === '/filing-details') {
            if (filing.activeTabKey === 1) this.searchFilingsByClient();
            else if (filing.activeTabKey === 2)
                this.searchFilingsReadyForRenewal();
            else if (filing.activeTabKey === 3) this.searchTerminatedFilings();
            else if (filing.activeTabKey === 4) this.searchEverActiveFilings();
        } else {
            clearFilingsReadyForRenewalTab();
            clearFilingsByClientTab();
            clearTerminatedFilingsTab();
            clearEverActiveFilingsTab();
            fetchAllClientInformationData(true);
        }
    }
    /*componentWillUnmount() {
        let {
            //clearFilingsReadyForRenewalSearch,
            //clearFilingsByFileByDateSearch
        } = this.props;
        //clearFilingsReadyForRenewalSearch();
        //clearFilingsByFileByDateSearch();
    }*/

    searchFilingsReadyForRenewal = () => {
        let {
            fetchFilingsReadyForRenewal,
            updateSelectedFilingList,
            filing
        } = this.props;
        updateSelectedFilingList([]);
        fetchFilingsReadyForRenewal(filing.readyForRenewalClientId);
    };

    searchTerminatedFilings = () => {
        let {
            fetchTerminatedFilings,
            updateSelectedFilingList,
            filing
        } = this.props;
        updateSelectedFilingList([]);
        fetchTerminatedFilings(filing.terminatedFilingsClientId);
    };

    searchEverActiveFilings = () => {
        let {
            fetchEverActiveFilings,
            updateSelectedFilingList,
            filing
        } = this.props;
        updateSelectedFilingList([]);
        fetchEverActiveFilings(filing.everActiveFilingsClientId);
    };

    searchFilingsByFileByDate = (clientId, startDate, endDate) => {
        let { fetchFilingsByFileByDate, updateSelectedFilingList } = this.props;
        updateSelectedFilingList([]);
        fetchFilingsByFileByDate({ clientId, startDate, endDate });
    };

    searchFilingsByClient = () => {
        let {
            fetchActiveFilingsByClientId,
            updateSelectedFilingList,
            filing
        } = this.props;
        updateSelectedFilingList([]);
        fetchActiveFilingsByClientId(filing.allActiveClientId);
    };

    updateClientSelected = clientVar => {
        let { updateClientSelected } = this.props;
        updateClientSelected(clientVar);
    };

    onChangeStatusSelectedClick = status => {
        let {
            filing,
            changeStatusFilingList,
            updateSelectedFilingList
        } = this.props;
        let selectedFilingIds = filing.selectedFilings.map(
            filing => filing.filingId
        );
        changeStatusFilingList(status, selectedFilingIds).then(response => {
            if (response.status === 200) {
                updateSelectedFilingList([]);
            }
        });
    };

    onEditClick = data => {
        let {
            history,
            fetchFilingById,
            fetchClientData,
            fetchStateData,
            updateFilingInfoData
        } = this.props;

        fetchFilingById(data.filingId).then(response => {
            if (response) {
                fetchClientData(response.clientId);
                fetchStateData(response.stateId);
            }
        });

        updateFilingInfoData(data);

        history.push({ pathname: '/filing-details', from: '/filings' });
    };

    handleTabSelect = key => {
        let { updateFilingsActiveTabKey } = this.props;
        updateFilingsActiveTabKey(key);
    };

    render() {
        let {
            filing,
            user,
            clientInformation,
            updateSelectedFilingList,
            roleName
        } = this.props;
        let isAdmin = roleName === 'Administrator';
        let holdForPaymentButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={() =>
                    this.onChangeStatusSelectedClick(
                        FILING_STATUS.HOLD_FOR_PAYMENT
                    )
                }
                disabled={filing.selectedFilings.length === 0}
            >
                Hold for payment
            </button>
        );
        let removeHoldForPaymentButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={() =>
                    this.onChangeStatusSelectedClick(
                        FILING_STATUS.READY_FOR_RENEWAL
                    )
                }
                disabled={filing.selectedFilings.length === 0}
            >
                Remove hold for payment
            </button>
        );
        let filingSentButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={() =>
                    this.onChangeStatusSelectedClick(FILING_STATUS.APPROVED)
                }
                disabled={filing.selectedFilings.length === 0}
            >
                Filing sent
            </button>
        );
        return (
            <div role="tabpanel" className="panel">
                <Tabs
                    activeKey={filing.activeTabKey}
                    onSelect={this.handleTabSelect}
                    id="filingsTab"
                    mountOnEnter={true}
                >
                    <Tab eventKey={1} title="All Active">
                        <div className="row">
                            <SearchAllActiveFilingsPanel
                                clientList={clientInformation.clients}
                                clientSelected={filing.allActiveClientId}
                                onClientChange={this.updateClientSelected}
                                onSearchClick={this.searchFilingsByClient}
                                user={user}
                            />
                        </div>
                        <div className="row">
                            {filing.filingsByClientsList.length > 0 && (
                                <Panel panelStyle="panel-default m0">
                                    <FilingsAllActiveListGrid
                                        id="allActiveFilings"
                                        dataList={filing.filingsByClientsList}
                                        handleEditClick={this.onEditClick}
                                    />
                                </Panel>
                            )}
                        </div>
                    </Tab>
                    <Tab eventKey={2} title="Ready for Renewal">
                        <div className="row">
                            <SearchReadyForRenewalPanel
                                clientList={clientInformation.clients}
                                clientSelected={filing.readyForRenewalClientId}
                                onClientChange={this.updateClientSelected}
                                onSearchClick={
                                    this.searchFilingsReadyForRenewal
                                }
                                user={user}
                            />
                        </div>
                        <div className="row">
                            {filing.searchReadyForRenewalResult.length > 0 && (
                                <Panel panelStyle="panel-default m0">
                                    <FilingsReadyForRenewalListGrid
                                        id="readyForRenewalFilings"
                                        dataList={
                                            filing.searchReadyForRenewalResult
                                        }
                                        handleEditClick={this.onEditClick}
                                    />
                                </Panel>
                            )}
                        </div>
                    </Tab>
                    <Tab eventKey={3} title="Terminated">
                        <div className="row">
                            <SearchTerminatedFilingsPanel
                                clientList={clientInformation.clients}
                                clientSelected={
                                    filing.terminatedFilingsClientId
                                }
                                onClientChange={this.updateClientSelected}
                                onSearchClick={this.searchTerminatedFilings}
                                user={user}
                            />
                        </div>
                        <div className="row">
                            {filing.terminatedFilingsList.length > 0 && (
                                <Panel panelStyle="panel-default m0">
                                    <FilingsTerminatedListGrid
                                        id="terminatedFilings"
                                        dataList={filing.terminatedFilingsList}
                                        handleEditClick={this.onEditClick}
                                    />
                                </Panel>
                            )}
                        </div>
                    </Tab>
                    <Tab eventKey={4} title="Ever Active">
                        <div className="row">
                            <SearchEverActiveFilingsPanel
                                clientList={clientInformation.clients}
                                clientSelected={
                                    filing.everActiveFilingsClientId
                                }
                                onClientChange={this.updateClientSelected}
                                onSearchClick={this.searchEverActiveFilings}
                                user={user}
                            />
                        </div>
                        <div className="row">
                            {filing.everActiveFilingsList.length > 0 && (
                                <Panel panelStyle="panel-default m0">
                                    <FilingsEverActiveListGrid
                                        id="everActiveFilings"
                                        dataList={filing.everActiveFilingsList}
                                        handleEditClick={this.onEditClick}
                                    />
                                </Panel>
                            )}
                        </div>
                    </Tab>
                </Tabs>
                {(filing.fetching || clientInformation.fetching) && <Spinner />}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    filing: state.employee.filing,
    clientInformation: state.employee.clientInformation,
    user: state.authentication.user,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchFilingById,
            updateFilingInfoData,
            fetchClientData,
            fetchStateData,
            changeStatusFilingList,
            fetchAllClientInformationData,
            fetchFilingsReadyForRenewal,
            fetchFilingsByFileByDate,
            fetchActiveFilingsByClientId,
            fetchTerminatedFilings,
            fetchEverActiveFilings,
            updateSelectedFilingList,
            clearFilingsReadyForRenewalTab,
            clearFilingsByClientTab,
            clearTerminatedFilingsTab,
            clearEverActiveFilingsTab,
            updateFilingsActiveTabKey,
            updateClientSelected
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SearchFilings));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SearchFilings/index.js